import type { FigmaIconProps } from './types';

export const IconFigmaCalendar = ({ size = 16, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.73307 4V1.33333C4.73307 1.00196 5.00196 0.733073 5.33333 0.733073C5.6647 0.733073 5.93359 1.00196 5.93359 1.33333V4C5.93359 4.33137 5.6647 4.60026 5.33333 4.60026C5.00196 4.60026 4.73307 4.33137 4.73307 4Z"
      fill={color}
    />
    <path
      d="M10.0664 4V1.33333C10.0664 1.00196 10.3353 0.733073 10.6667 0.733073C10.998 0.733073 11.2669 1.00196 11.2669 1.33333V4C11.2669 4.33137 10.998 4.60026 10.6667 4.60026C10.3353 4.60026 10.0664 4.33137 10.0664 4Z"
      fill={color}
    />
    <path
      d="M13.3997 4C13.3997 3.59499 13.0717 3.26693 12.6667 3.26693H3.33333C2.92832 3.26693 2.60026 3.59499 2.60026 4V13.3333C2.60026 13.7383 2.92832 14.0664 3.33333 14.0664H12.6667C13.0717 14.0664 13.3997 13.7383 13.3997 13.3333V4ZM14.6003 13.3333C14.6003 14.4011 13.7344 15.2669 12.6667 15.2669H3.33333C2.26558 15.2669 1.39974 14.4011 1.39974 13.3333V4C1.39974 2.93225 2.26558 2.06641 3.33333 2.06641H12.6667C13.7344 2.06641 14.6003 2.93225 14.6003 4V13.3333Z"
      fill={color}
    />
    <path
      d="M14 6.06641C14.3314 6.06641 14.6003 6.3353 14.6003 6.66667C14.6003 6.99804 14.3314 7.26693 14 7.26693H2C1.66863 7.26693 1.39974 6.99804 1.39974 6.66667C1.39974 6.3353 1.66863 6.06641 2 6.06641H14Z"
      fill={color}
    />
  </svg>
);
